import styled from 'styled-components';
import cls from 'classnames';
import { ReactNode } from 'react';
import {
  paradigmLightBlue,
  portage10,
} from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import {
  TabId,
  useLeaderboardTabsActions,
  useLeaderboardTabsView,
} from '@paradigm/features/src/leaderboard/contexts/tabs';

export const TabContainer = styled.div`
  margin: 0px 1rem 1rem;
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 1px 0 0 0;
  }
`;
interface TabProps {
  readonly tabId: TabId;
  readonly label?: string;
  readonly disabled?: boolean;
  readonly children: ReactNode;

  /**
   * Linked tabs are tabs that should be considered active when this tab is active.
   */
  readonly linkedTabs?: TabId[];
  readonly className?: string;
  readonly badge?: ReactNode;
}

export function Tab({
  tabId,
  children,
  label,
  linkedTabs,
  badge,
  className,
  disabled = false,
}: TabProps) {
  const { activeTab } = useLeaderboardTabsView();
  const { setActiveTab } = useLeaderboardTabsActions();
  const isActive = activeTab === tabId || linkedTabs?.includes(activeTab);

  return (
    <BaseTab
      role="tab"
      aria-label={label}
      aria-controls={tabId}
      aria-selected={isActive === true ? 'true' : 'false'}
      className={cls({ active: isActive }, className)}
      data-testid={`${tabId}-tab`}
      onClick={() => setActiveTab(tabId)}
      disabled={disabled}
    >
      {badge}
      <Text className={cls({ active: isActive })}>{children}</Text>
    </BaseTab>
  );
}
export const LeaderboardTable = styled.div`
  margin: 50px;
  background-color: red;
`;

export const LeaderboardFiltersSectionMobile = styled.div`
  display: flex;
  margin: 20px 16px;
  align-items: center;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    justify-content: space-between;
  }
`;

export const LeaderboardFiltersMobile = styled.div`
  display: grid;
  margin: 20px 16px;
  gap: 25px;
`;
export const DividerMobile = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 2px solid ${paradigmLightBlue};
  opacity: 0.1;
`;

const Text = styled.span`
  font-weight: 600;
  opacity: 0.5;
  &.active {
    opacity: 1;
    color: ${paradigmLightBlue};
  }
`;

export const BaseTab = styled.button`
  border: none;
  margin-left: 29.5px;
  margin-right: 29.5px;
  display: flex;
  align-items: center;
  background: transparent;
  padding: 0;
  padding-bottom: 5px;
  position: relative;
  color: white;
  transition: 0.25s ease all;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    border-bottom: 2px solid ${portage10};
  }
  &:hover {
    color: ${paradigmLightBlue};
    cursor: pointer;
    opacity: 1;
    text-shadow: 0 0 7px 10px rgba(68, 85, 255, 0.7);

    @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      border-bottom: 2px solid ${portage10};
    }
  }

  &.active {
    &::after {
      background-color: #7fabec;
      box-shadow: 0 0 7px 0 rgba(68, 85, 255, 0.7);
    }
  }
  &::after {
    width: 100%;
    height: 2px;
    border-radius: 1px;
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    transition: 0.25s ease all;
  }

  &:disabled {
    opacity: 0.9;
    cursor: not-allowed;
  }
`;
